import React from "react";
import UseContext from "../../hooks/useContext";
import useModal from "../modal/useModal";
import { SettingRow } from "../settings/SettingRow";

function TimeCutBlock({ timeCut, isWaiting, onCommitTimeCut }) {
  const { setModalData } = UseContext();
  const { toggle } = useModal();

  const minutes =
    timeCut === "" || timeCut === undefined || timeCut === null
      ? 0
      : Number(timeCut);

  const openModal = () => {
    setModalData({
      block: "timeCut",
      timeCut,
      isWaiting,
      commitTimeCut: onCommitTimeCut,
      modalSessionKey: Date.now(),
    });
    toggle("settings_edit_block");
  };

  const description = isWaiting ? (
    <div className="h-4 max-w-md animate-pulse rounded bg-gray-200" />
  ) : (
    <>
      À partir de{" "}
      <strong className="font-semibold text-gray-800">{minutes}m</strong>, les
      pauses sont comptées comme des coupures
    </>
  );

  return (
    <SettingRow
      title="Calcul des coupures"
      description={description}
      onEdit={openModal}
    />
  );
}

export default TimeCutBlock;
